import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon } from 'lucide-react';
const included = ['Guía Maestra completa en PDF', 'Protocolo de 14 días paso a paso', 'Checklist de Cocina y Baño', 'Lista de Compra Segura', 'Acceso inmediato y descarga instantánea'];
interface OfferProps {
  id?: string;
}
export function Offer({
  id
}: OfferProps) {
  return <section id={id} className="relative w-full overflow-hidden bg-sage-soft py-20 md:py-28" data-id="element-176">
      <div className="pointer-events-none absolute -top-24 -right-24 w-80 h-80 rounded-full bg-blush opacity-40 blur-3xl" aria-hidden="true" data-id="element-177" />
      <div className="pointer-events-none absolute -bottom-32 -left-24 w-80 h-80 rounded-full bg-sky-pastel opacity-40 blur-3xl" aria-hidden="true" data-id="element-178" />

      <div className="relative max-w-4xl mx-auto px-6 md:px-8" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 border border-sage/30" data-id="element-180">
          <div className="text-center mb-8" data-id="element-181">
            <span className="inline-block bg-blush-soft text-blush-ink text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-4" data-id="element-182">
              Oferta especial
            </span>
            <h2 className="font-serif text-3xl md:text-4xl text-ink mb-4" data-id="element-183">
              Limpia tu camino hacia el positivo hoy mismo
            </h2>
            <p className="text-lg text-ink-soft" data-id="element-184">
              Consigue "El Detox Invisible" y comienza tu transformación
            </p>
          </div>

          <div className="bg-cream rounded-2xl p-8 md:p-10 mb-6" data-id="element-185">
            <div className="text-center mb-8" data-id="element-186">
              <div className="flex items-baseline justify-center gap-4 mb-2" data-id="element-187">
                <span className="text-2xl text-ink-muted line-through font-serif" data-id="element-188">
                  $27
                </span>
                <span className="font-serif text-6xl md:text-7xl text-sage-deep font-semibold" data-id="element-189">
                  $6.39
                </span>
                <span className="text-lg text-ink-soft font-semibold" data-id="element-190">USD</span>
              </div>
              <p className="inline-block bg-blush-soft text-blush-ink text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full mb-2" data-id="element-191">
                Ahorra 76% · Solo hoy
              </p>
              <p className="text-ink-muted text-sm" data-id="element-192">
                Pago único · Acceso de por vida
              </p>
            </div>

            <div className="space-y-3 mb-8" data-id="element-193">
              {included.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-194">
                  <div className="flex-shrink-0 inline-flex items-center justify-center w-6 h-6 rounded-full bg-sage-deep mt-0.5" data-id="element-195">
                    <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-196" />
                  </div>
                  <span className="text-ink-soft" data-id="element-197">{item}</span>
                </div>)}
            </div>

            <motion.a href="https://vitaliavida.com/cart/52595253346591:1" className="w-full inline-flex items-center justify-center gap-2 bg-sage-deep text-white py-5 rounded-full font-bold text-lg md:text-xl shadow-lg" whileHover={{
            y: -2,
            boxShadow: '0 14px 34px rgba(148, 181, 142, 0.45)'
          }} whileTap={{
            scale: 0.98
          }} data-id="element-198">
              DESCARGAR MI PROTOCOLO AHORA
              <span aria-hidden="true" data-id="element-199">→</span>
            </motion.a>

            <div className="flex items-center justify-center gap-2 text-sm text-ink-muted mt-4" data-id="element-200">
              <ShieldCheckIcon className="w-4 h-4 text-sage-deep" data-id="element-201" />
              <span data-id="element-202">Acceso inmediato. Garantía de satisfacción.</span>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 text-xs text-ink-muted" data-id="element-203">
            <LockIcon className="w-3.5 h-3.5" data-id="element-204" />
            <span data-id="element-205">Pago seguro procesado con encriptación SSL</span>
          </div>
        </motion.div>
      </div>
    </section>;
}